<template>
  <div>
    <v-dialog v-model="dialog" persistent width="900">
        <v-card>
            <v-card-title>
                <span class="headline">図面仕上がり予定表 <b>({{bundle_sched}} SCHEDULE)</b><br>
                    <b>{{customerCode}} {{planNumber}} ({{sched_header}})</b>
                    <!-- <v-checkbox v-if="enableIcadCheck" @click="removeP76()" v-model="icadPlanCheck" dark label="iCAD Plan?"></v-checkbox> -->
                </span>
                <v-spacer/><span v-if="enableIcadCheck"><v-checkbox @click="removeP76()" :disabled="isICadCheckboxDisabled" v-model="icadPlanCheck" class="mt-5" dark label="iCAD Plan?"></v-checkbox></span><v-spacer/>
            </v-card-title>
            <v-container>
                <v-card-text>
                    <v-container>
                        <v-row no-gutters>
                            <v-col cols="12">
                                <v-simple-table class="mainTable">
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th>FILE TYPE(CODE)</th>
                                            <th>BOSS REMARKS</th>
                                            <th>DUE DAY</th>
                                            <th>ACTION</th>
                                            <th>HRDID</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in forRegistrationList" :key="index" >
                                            <td>
                                                <v-checkbox v-model="item.checkBox"></v-checkbox>
                                            </td>
                                            <td @click="rowClicked(item, index)">{{ item.temp }}</td>
                                            <td @click="rowClicked(item, index)">{{ item.cad_remarks }}</td>
                                            <td @click="rowClicked(item, index)">
                                                <div v-if="item.boss_code == '202'">
                                                    {{ item.due_day_boss ? item.due_day_boss : '-' }}
                                                </div>
                                                <div v-else>
                                                    {{ item.due_day ? item.due_day : '-' }}
                                                </div>
                                            </td>
                                            <td>
                                                <v-btn icon @click="openChangeDueDialog(item, index)">
                                                    <v-icon color="green">mdi-circle-edit-outline</v-icon>
                                                </v-btn>
                                            </td>
                                            <td @click="rowClicked(item, index)">{{item.HRD_ID}}</td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
            </v-container>
            <v-card-actions>
                <v-spacer></v-spacer>
                <!-- <v-btn @click="confirmAlvs()">Confirm</v-btn> -->
                <!-- :disabled="isDisabled" -->
                    <v-btn dark color="red" @click="toggleBossListDialog(false)">キャンセル</v-btn>
                    <v-btn dark color="green" @click="confirmBoss()">保存</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="changeDueDialog" width="400">
        <div>
            <v-card>
                <v-card-title>
                    Edit Due Date/Time
                </v-card-title>
                <v-card-text>
                    <v-row>

                        <v-col>
                            <v-menu
                                v-model="dueDateMenu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        outlined
                                        dense
                                        v-model="changedDueDateTime.date"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on">
                                    </v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="changedDueDateTime.date"
                                    @input="dueDateMenu = false"
                                >
                                </v-date-picker>
                            </v-menu>
                        </v-col>

                        <v-col>
                            <v-text-field v-model="changedDueDateTime.time"
                                outlined
                                dense
                                :label="label"
                                :value="changedDueDateTime.time"
                                :rules="timeRules"
                                required
                                v-time-format
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-card-actions>
                        <v-btn @click="closeDueDialog()" color="green" dense>保存</v-btn>
                    </v-card-actions>
                </v-card-text>
            </v-card>
        </div>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';
export default {
    props: {
        dialog: Boolean
    },

    data(){
        return {
            // newDueDate: null,
            getDueDay: null,
            getExistingDueDay : null,
            getEditBoss: null,
            customerCode: null,
            planNumber: null,
            sched: null,
            forRegistrationList: [],
            changeDueDialog: false,
            isICadCheckboxDisabled: false,
            dueDateMenu: false,
            dueDate: null,
            enableIcadCheck: false,
            changedDueDateTime: {
                time: null,
                date: null,
            },
            icadPlanCheck: true,
            label: 'Time',
            timeRules: [
                v => !!v || 'Time is required', // Required validation
                v => /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(v) || 'Invalid time format' // Regex validation for time format (HH:mm)
            ]
        }
    },
    directives: {
        'time-format': {
        // Insert a colon after entering 2 digits for the hour part
            bind(el) {
                el.addEventListener('input', function (event) {
                    const inputValue = event.target.value;
                    if (inputValue.length === 2 && !inputValue.includes(':')) {
                        event.target.value = inputValue + ':';
                    }
                });
            }
        },  
    },

    computed: {
        ...mapState([
            'forRegistration',
            'sched_header',
            'bundle_sched',
            'editCadRequestRevisionContent',
            'cadRequestRevisionContent',
            'existingRevisions',
            'gravityBoss',
        ]),

        // isICadCheckboxDisabled(){
        //     console.log()
        //     // return this.existingRevisions.gravity_type == '5D';
        // },
    },


    methods: {
        // deleteBundleSched(ii){
        //     this.forRegistration.splice(indexToRemove, 1);
        // },
        removeP76(){
            if(!this.icadPlanCheck) this.forRegistrationList = this.$store.state.forRegistration.filter(item => item.boss_code !== 'P76');
            else if (this.icadPlanCheck && this.$store.state.gravityBoss.gravity == "0") this.forRegistrationList =  this.$store.state.forRegistration.filter(item => item.boss_code !== 'P76');
            else this.forRegistrationList = this.$store.state.forRegistration;

            // console.log(this.forRegistrationList,'forRegistrationList')
        },
        rowClicked(item, index) {
            // Trigger checkbox only if the click did not originate from the edit button
            if (!this.isEditButtonClicked(event)) {
                item.checkBox = !item.checkBox;
            }
        },
        isEditButtonClicked(event) {
            // Check if the click event originated from the edit button
            return event.target.tagName === 'V-ICON' && event.target.parentElement.tagName === 'V-BTN';
        },

        getXmlDay(){
            axios({
                method: 'POST',
                url: 'api/existing_xml_due',
                data:{ 
                    customer_code : this.$store.state.getXml 
                }
            }).then((res) => {
                this.getExistingDueDay = res.data;
            })
        },

        closeDueDialog(){   
            let newDueDate = moment().format(`${this.changedDueDateTime.date} ${this.changedDueDateTime.time}`);
            this.forRegistrationList[this.dueIndex].due_day = newDueDate;
            this.changeDueDialog = false;

            // SAVE AND UPDATE -> EDIT BOSS DUE DAY
            axios({
                method: 'POST',
                url: 'api/xml_due_day',
                data: {
                    // HRD_ID : this.getEditBoss.HRD_ID,
                    cad_request_id : this.getEditBoss.cad_request_id,
                    customer_code : this.getEditBoss.code_number,
                    plan_number : this.getEditBoss.plan_number,
                    boss_code : this.getEditBoss.boss_code,
                    cad_remarks : this.getEditBoss.cad_remarks,
                    due_day : newDueDate,
                }
            }).then((res) => {
                this.getDueDay = res.data
                this.getXmlDay();
            })
            // END
        },
        openChangeDueDialog(item, ii){
            this.getEditBoss = {...item}
            // console.log(item,'item')
            this.dueIndex = ii
            
            // Check if item.due_day is a valid date before formatting
            if (moment(item.due_day).isValid()) {
                this.changeDueDialog = true;
                this.changedDueDateTime.time = moment(item.due_day).format("HH:mm");
                this.changedDueDateTime.date = moment(item.due_day).format("YYYY-MM-DD");

                // IF USER EDIT THE DUE DAY BEFORE REGSITER, NEW DUE DAY WILL SHOW
                this.getExistingDueDay.forEach(element => {
                    if(element.code_number == item.code_number && element.plan_number == item.plan_number && element.boss_code == item.boss_code && element.cad_remarks == item.cad_remarks) {
                        this.changedDueDateTime.time = moment(element.due_day).format("HH:mm");
                        this.changedDueDateTime.date = moment(element.due_day).format("YYYY-MM-DD");
                    }
                });
                // END
            } else {
                // Handle the case where item.due_day is not a valid date
                console.error("Invalid date format in item.due_day:", item.due_day);
                // You might want to set a default value or show an error message here.
            }

        },
        confirmBoss(){
            this.$store.state.registerDate = moment().format('YYYY-MM-DD HH:mm:ss')
            // console.log(this.$store.state.registerDate,'this.$store.state.registerDate')
            let register = []
            let isBossCodeP76Present = this.forRegistrationList.some((r) => {
                return r.checkBox && r.boss_code === 'P76';
            });
            // console.log(isBossCodeP76Present,'isBossCodeP76Present')
            if(isBossCodeP76Present){
                this.forRegistrationList.filter((r) => {
                    // console.log(r,'rararaaararar')
                    if(r.checkBox){
                        if(typeof r.remarks === 'string'){
                            r.remarks = JSON.parse(r.remarks);
                        }
                        r.remarks.icad_plan = '0';
                        r.icad_plan = 0;
                        register.push(r)
                    }
                })
            }else {
                this.forRegistrationList.filter((r) => {
                    if(r.checkBox){
                        if(typeof r.remarks === 'string'){
                            r.remarks = JSON.parse(r.remarks);
                        }
                        r.remarks.icad_plan = '0';
                        r.icad_plan = 0;
                        register.push(r)
                    }
                })
            }
            
            this.$emit('confirmBoss', register)
            this.toggleBossListDialog(false);

        },

        toggleBossListDialog(value){
            this.$emit('toggleBossListDialog', value)
        },
    },

    mounted() {
        this.getXmlDay();
    },

    watch: {
        icadPlanCheck(newVal) { // Pag naka false agad yung checkbox matik mawawala rin yung iCad kahit hindi na iclick yung removeP76
            if (!newVal) {
                this.removeP76();
            }
        },
        dialog(val){
            // console.log(this.$store.state.forHouseCategory,'this.$store.state.forHouseCategory')
            if(val){
                // NEW BOSS SCHEDULE EDIT
                //     let new_boss = this.getExistingDueDay.map(elemental => {
                //         return elemental;
                //     })
                //     console.log(new_boss,'new_boss')
                //     let exist_sched = this.$store.state.forRegistration.map(itemx => {
                //         return itemx;
                //     })
                //     new_boss.forEach(newBossItem  => {
                //         exist_sched.forEach(existSchedItem => {
                //             if(newBossItem.boss_code === existSchedItem.boss_code && newBossItem.cad_remarks == existSchedItem.cad_remarks && newBossItem.code_number == existSchedItem.code_number && newBossItem.plan_number == existSchedItem.plan_number) {
                //                 existSchedItem.due_day = moment(newBossItem.due_day).format('YYYY-MM-DD HH:mm');
                //                 // console.log('Boss Code:', newBossItem)
                //             }
                //         })
                //     });
                
                // END
                this.enableIcadCheck = false
                // console.log(this.$store.state.cadRequestBasicInformation)
                
                // if(this.$store.state.cadRequestBasicInformation.house_type_category == 2) {
                // // if(this.$store.state.forHouseCategory == 2 || this.$store.state.forAlias == 'waku') { // <- ayaw gumana nito kasi hahanapin nya ang checkBox
                //     this.enableIcadCheck = true;
                //     this.icadPlanCheck = true;
                // } 
                // else {
                //     this.enableIcadCheck = true;
                //     this.icadPlanCheck = true;
                // }
                // if(this.$store.state.cadRequestBasicInformation.house_type_category == 3) {
                // if(this.$store.state.forHouseCategory == 3 || this.$store.state.forAlias == 'jiku') {
                if(this.$store.state.forHouseCategory == 3 || this.$store.state.forAlias == 'jiku') {
                    this.isICadCheckboxDisabled = true;
                    this.enableIcadCheck = true;
                    this.icadPlanCheck = false;
                } else if(this.$store.state.forHouseCategory == 2 || this.$store.state.forAlias == 'waku') {
                    this.enableIcadCheck = true;
                    this.icadPlanCheck = true;
                }
                // console.log(this.cadRequestRevisionContent,'cadRequestRevisionContent')
                // console.log(this.gravityBoss,'this.gravityBoss.gravity_type')

                if(!this.enableIcadCheck) {
                    this.forRegistrationList = this.$store.state.forRegistration.map(item => {
                        if (item.boss_code !== 'P76') {
                            if (item.boss_code === '202') {
                                const item201 = this.$store.state.forRegistration.find(r => r.boss_code === '201');
                                item.due_day_boss = item201 ? item201.due_day : null;
                            }
                            return item;
                        }
                    });
                }else {
                    // IF HOUSE TYPE IS JIKUGUMI iCAD CHECKBOX HIDE AND UNCHECK
                    // if(this.$store.state.forHouseCategory == 3 || this.$store.state.forAlias == 'jiku') {
                    //     this.isICadCheckboxDisabled = true;
                    //     this.icadPlanCheck = false;
                    // }

                    // DISABLED ICAD CHECKBOX IF THE GRAVITY(0) AND GRAVITY TYPE(5D) AND COPYPREV IS CHECKED (this.$store.state.gravityBoss.gravity == "0" ||  this.$store.state.gravityBoss.gravity_type == "5D" || this.$store.state.gravityBoss.revision_type == '8')
                    if(this.$store.state.gravityBoss.revision_type == "7"  && !/[a-zA-Z]/.test(this.$store.state.gravityBoss.revision_number)){
                        this.isICadCheckboxDisabled = true;
                        this.icadPlanCheck = false;
                        this.forRegistrationList = this.$store.state.forRegistration.filter(item => {
                                if (item.boss_code !== 'P76') {
                                    if (item.boss_code === '202') {
                                        const item201 = this.$store.state.forRegistration.find(r => r.boss_code === '201');
                                        item.due_day_boss = item201 ? item201.due_day : null;
                                    }
                                    return item;
                                }
                        });
                        //NOTE : IF WITH 003 AND WITH FP, NO NEED TO REGISTER TO BOSS EVEN FP IS WITH CIRCLE 
                        const hasCode003 = this.forRegistrationList.some(item => item.boss_code === '003');
                        if (!hasCode003) {
                            this.forRegistrationList = this.forRegistrationList.filter(item => item.boss_code !== 'P79');
                        }
                    } else {
                        this.isICadCheckboxDisabled = false;
                        this.forRegistrationList = this.$store.state.forRegistration.map(item => {
                            if (item.boss_code === '202') {
                                const item201 = this.$store.state.forRegistration.find(r => r.boss_code === '201');
                                item.due_day_boss = item201 ? item201.due_day : null;
                            }
                            return item;
                        });

                        if(this.icadPlanCheck) {
                            if(this.$store.state.gravityBoss.gravity == '0' || this.$store.state.getBossiCad.gravity == '0' || this.$store.state.getBossiCad.isHrdCpn == 1) {
                                this.forRegistrationList = this.$store.state.forRegistration.filter(item => item.boss_code !== 'P76');
                            }
                        }
                        
                    }
                }
                    // console.log(this.forRegistrationList, 'forRegistrationList')
                    // console.log(this.forRegistration,'forRegistration')
                    this.customerCode = this.forRegistrationList.length > 1 ? this.forRegistrationList[1].code_number : this.forRegistrationList[0].code_number;
                    this.planNumber = this.forRegistrationList.length > 1 ? this.forRegistrationList[1].plan_number : this.forRegistrationList[0].plan_number;
                    // console.log(this.forRegistrationList,'registrations')
                    // this.sched_header = this.forRegistrationList.length > 1 ? this.forRegistrationList[1].bracket_name : this.forRegistrationList[0].bracket_name
            }
        }
    }
}
</script>

<style>

</style>